import React from 'react'

export default function ServiceTop({ image, text, title, secImage }) {
    return (
        <>
            <div className="service_top">
                <img src={image} className="service_top_img" />
                <div className="responsive-image-text">
                    <div className="title--image">
                        <img src={secImage} />
                        <h1>{title}</h1>
                    </div>
                    <p className="service__text">{text}</p>
                </div>

            </div>
        </>
    )
}
